import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import { EGDSRadioButtonGroupContext } from '../radio-button-group-provider/index.esm.js';
import styles from '../../styles/uitk-egds-radio-button.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { useEGDSContext } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSRadioButtonGroup = props => {
  const {
    children,
    className,
    defaultChecked,
    errorMessage,
    group,
    legendLabel,
    selected,
    onChange
  } = props;
  const wrapperClassNames = getClassNameList('uitk-radio-button-group', className);
  const errorClassNames = getClassNameList('uitk-radio-button-error');
  const {
    data: contextData
  } = useEGDSContext();
  const {
    hasRequiredFieldIndicator,
    collapsed,
    srMessage
  } = contextData ?? {};
  const radioButtonGroupContextValue = React.useMemo(() => ({
    onChange,
    defaultChecked,
    group,
    selected,
    hasRequiredFieldIndicator
  }), [onChange, defaultChecked, group, selected, hasRequiredFieldIndicator]);
  return jsxs("fieldset", {
    className: wrapperClassNames,
    children: [jsxs("legend", {
      className: "is-visually-hidden",
      children: [legendLabel || group, collapsed && (srMessage ? `. ${srMessage}` : '')]
    }), errorMessage && jsxs(EGDSLayoutFlex, {
      space: "xsmall",
      alignItems: "center",
      className: errorClassNames,
      children: [jsx(EGDSLayoutFlexItem, {
        alignSelf: "start",
        children: jsx(EGDSIcon, {
          name: "error_outline",
          size: EGDSIconSize.SMALL
        })
      }), errorMessage]
    }), jsx(EGDSRadioButtonGroupContext.Provider, {
      value: radioButtonGroupContextValue,
      children: children
    })]
  });
};
export { EGDSRadioButtonGroup };